module.exports = "/_next/static/images/052880b06c3883198a9d51b50bb1774d-features-meal-lg.jpg";